import {
    CategoryTextDto,
    MenuDto,
    OptionBasicDto,
    OptionBasicReferenceDto,
    PDiPOptionBasicDto
} from "../../services/Client";
import {AnyAction} from "redux";
import {ITableSort} from "../../utils/SortUtils";
import {Dispatch} from "react-redux";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import {GetOBPDiPListParam} from "../../services/HATEOASClient";
import GeneralActions from "./GeneralActions";
import {ActionTypes} from "./ActionTypes";
import {IReduxState} from "../IReduxState";

const BaseOptionViewActions = {
    ReceiveBaseOptionsAreaExtraLinksAction(dto: MenuDto): AnyAction {
        return {type: ActionTypes.RECEIVE_BASE_OPTIONS_AREA_EXTRA_LINKS, baseOptionsAreaExtraLinks: dto};
    },
    SetOptionBasicTableSort(sortObject: ITableSort): AnyAction {
        return {type: ActionTypes.SET_OPTION_BASIC_TABLE_SORT, sortObject};
    },
    GetOptionBasicPDiPList(t: reactI18Next.TranslationFunction, menuDto: MenuDto, mj4: number) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const loadingScreenMessage = t('GLOBAL:LOAD_OPTION_BASIC_PDIP');
            const {client} = getState().general;
            if (!client.GET_optionBasicPDiPList(menuDto).canExecute()) {
                renderErrorToast({
                    message: "ERRORS:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:GET_OPTION_BASIC_PDIP",
                    timestamp: Date.now()
                }
                );
                return;
            }

            const reqParam: GetOBPDiPListParam = {
                mj4: mj4
            };
            dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));
            client.GET_optionBasicPDiPList(menuDto).execute(reqParam)
                .then((result) => {
                    dispatch(this.SetOptionBasicPDiPList(result));
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                }).catch((reason) => {
                    renderErrorToast({
                        message: "ERRORS:LOAD_OPTION_BASIC_PDIP",
                        details: reason,
                        timestamp: Date.now()
                    }
                    );
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                });
        };
    },
    GetOptionBasicReferences(
        dto: OptionBasicDto,
        setMessage: (message: string) => void,
        setResult: (references: OptionBasicReferenceDto[]) => void,
    ) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            setMessage("BASEOPTIONS:LOAD_REFERENCES");
            const {client} = getState().general;
            if (!client.GET_optionBasicReferences(dto).canExecute()) {
                setMessage("GLOBAL:MISSING_ACCESS_RIGHTS");
            }

            client.GET_optionBasicReferences(dto).execute()
                .then((result) => {
                    setMessage("");
                    setResult(result);
                }).catch(() => {
                    setMessage("ERRORS:LOAD_REFERENCES_FAIL");
                });
        };
    },
    SetOptionBasicPDiPList(dtos: PDiPOptionBasicDto[]) {
        return {type: ActionTypes.SET_OPTION_BASIC_PDIP_LIST, data: dtos};
    },
    SetSerCategoryDtos(dtos: CategoryTextDto[]) {
        return {type: ActionTypes.SET_SER_CATEGORIES, data: dtos};
    },
    SetNonSerCategoryDtos(dtos: CategoryTextDto[]) {
        return {type: ActionTypes.SET_NON_SER_CATEGORIES, data: dtos};
    },
};

export default BaseOptionViewActions;



// WEBPACK FOOTER //
// ./src/redux/actions/BaseOptionViewActions.tsx